import { useState, useEffect } from 'react';

const SCREEN_SM = 1023;

interface displaySize {
    width: number;
    isScreenSm: boolean;
}

export const useResize = (): displaySize => {
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = event => {
            setWidth(event.target.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    
    return {
        width,
        isScreenSm: width <= SCREEN_SM,
    };
};
